import React from 'react';
import { Container,Card } from "react-bootstrap";
import { Layout, Row, Col, Tabs } from 'antd';
import CodeBlockComponent from '../components/dashboard/CodeBlockComponent';
import VistaPreviaComponent from '../components/audio/VistaPrevia';
import * as constant from './../../constants/constants'

const { Header, Content } = Layout;
const { TabPane } = Tabs;

const htmlCode = constant.au_htmlpage;
const codeHTML = constant.au_html;
const codeJS = constant.au_js;
const codeCSS = constant.au_css;

export default function AudioPage(){
  return(
    <Container className="content">
      <Content >
         <Row>
          <span className='h3 mt-1 text-black'>Audio</span>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} xl={12} className=''>
            <Card className="code-card">
              <Card.Body>
                <span className='fs-5'>Código HTML</span>
                <Tabs defaultActiveKey="1" >
                  <TabPane tab="HTML" key="1"  >
                    <CodeBlockComponent code={codeHTML} language="html" />
                  </TabPane>
                  <TabPane tab="JavaScript" key="2">
                    <CodeBlockComponent code={codeJS} language="javascript" />
                  </TabPane>
                  <TabPane tab="CSS" key="3">
                    <CodeBlockComponent code={codeCSS} language="css" />
                  </TabPane>
                </Tabs>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={24} xl={12}>
            <Card className="code-card">
              <Card.Body>
                <span className='fs-5'>Vista previa</span>
                <div className='mt-2' style={{border:"1px solid #eee"}}>
                  <VistaPreviaComponent ContenidoHTML={ htmlCode} />
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Content>
    </Container>
  )
}